import { render, staticRenderFns } from "./AssinaturaFd.vue?vue&type=template&id=1db51c3e&scoped=true&"
import script from "./AssinaturaFd.vue?vue&type=script&lang=js&"
export * from "./AssinaturaFd.vue?vue&type=script&lang=js&"
import style0 from "./AssinaturaFd.vue?vue&type=style&index=0&id=1db51c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db51c3e",
  null
  
)

export default component.exports